import { render } from "./AdminSendNotification.vue?vue&type=template&id=4e09d7c0&scoped=true&ts=true"
import script from "./AdminSendNotification.ts?vue&type=script&lang=ts"
export * from "./AdminSendNotification.ts?vue&type=script&lang=ts"

import "./AdminSendNotification.vue?vue&type=style&index=0&id=4e09d7c0&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e09d7c0"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn});
